import { api } from '@/lib/api';
import { queryClient } from '@/providers/query-client';
import { LoaderFunctionArgs } from 'react-router-dom';

export async function reportLoader({ params }: LoaderFunctionArgs) {
    const report = await queryClient.fetchQuery({
        queryKey: ['report', params.id],
        queryFn: async () => {
            if (!params.id) {
                return;
            }

            const response = await api.report.getReport(params.id);

            if (!response.ok) {
                throw new Error(response.error);
            }

            return response.data;
        },
    });

    return report;
}
